(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"));
	else if(typeof define === 'function' && define.amd)
		define("fast-downloads", ["bluebird"], factory);
	else if(typeof exports === 'object')
		exports["fast-downloads"] = factory(require("bluebird"));
	else
		root["fast-downloads"] = factory(root["bluebird"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return 